import { DHLLogo } from "@App/Components/atoms/whitelabel/logos/DHLLogo";
import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import type { Config } from "@App/configs/interfaces";

/**
 * Configuration for the DHL whitelabel.
 * Extends the default configuration with specific settings for DHL.
 */
export const config: Partial<Config> = {
  slug: "dhl",
  navbar: {
    logos: {
      left: {
        component: <DHLLogo />,
      },
      right: {
        component: <RepareoLogo />,
      },
    },
    backToPartnerButton: {
      url: "https://www.dhl.de",
    },
  },
  reviews: {
    show: true,
  },
};

export default config;
